import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import axios from 'axios';
import "./About.css"
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
export default function About() {
    const [code, setCode] = useState('');
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/getCode`).then(res => {
            setCode(res.data)
        })

    }, [])
    //
    return (
        <>
            <Navbar />
            <React.Fragment >
                <div className="body-about">
                    <header className="header-about">
                        <div className='header-left'>
                            <h1 className='h1-head'>UDLA<br /> Capture The Flag</h1>
                            <p>Una plataforma creada para el aprendizaje de ciberseguridad. </p>
                            <Link to="/registro">Registrate ahora</Link>

                        </div>
                        <div className='header-right'>
                            <img src="/aboutComputer.png" alt='computerLogo'></img>
                        </div>

                    </header>


                    <main>
                        <section className="services">
                            <h2 className="h2-services">¿Por qué UDLA CTF?</h2>

                            <div className="service-container">
                                <div className="services-card service-one"></div>
                                <div className="service-description">

                                    <h3>Sección de CTF</h3>
                                    <div>Esta sección permite participar en las competencias de Capture The Flag organizadas
                                        por la UDLA. Para competir solo necesitas registrarte, crear tu equipo y esperar que empiece la siguiente competencia.
                                        En las competencias encontrarás vario retos desafiantes, que pondrán a prueba tu conocimiento y te ayudarán a
                                        adquirir experiencia en el campo de la ciberseguridad. </div>

                                </div>
                            </div>



                            <div className="service-container">

                                <div className="services-card service-two"></div>
                                <div className="service-description">
                                    <h3>Sección de Aprendizaje</h3>
                                    <div>Esta sección tiene como objetivo brindar una enseñanza tanto
                                        teórica como práctica, mediante módulos de aprendizaje. Estos módulos
                                        se dividen en diferentes categorías y niveles. Cada uno de ellos tiene su respectivo
                                        contenido de aprendizaje y retos, que te permitirán prepararte para las competencias de CTF.
                                    </div>
                                </div>
                            </div>



                            <div className="service-container">
                                <div className="services-card service-three"></div>
                                <div className="service-description">
                                    <h3>Sección de Writeups</h3>
                                    <div>Lo mejor que se puede compartir es el conocimiento - Alain Ducasse.
                                        Por ello, esta sección es un repositorio para tener los enlaces a los
                                        writeups que los estudiantes han ido resolviendo de varias competencias,
                                        con el fin de tener un aprendizaje colaborativo.

                                    </div>
                                </div>

                            </div>
                        </section>

                        <section>
                            <h2 className="h2-services">Equipo de desarrollo</h2>
                            <br />

                            <div className='footer'>
                                <div className='containerP'>
                                    <img src='/authors/fotoIvan.jpeg' alt='fotoIvan' className='fotoPerfil'></img>
                                    <div className='descriptionP'>
                                    <h1>Ing. Iván Ortiz</h1>
                                    <h4>DIRECTOR DEL PROYECTO</h4>
                                    </div>
                                </div>
                                <div className='containerP'>
                                        <img src='/authors/fotoRommel.png' alt='fotoRommel' className='fotoPerfil'></img>
                                        <div className='invisible'>El código está aquí</div>
                                        <div className='invisible'>{code}</div>
                                        <div className='descriptionP'>
                                        <h1>Est. Rommel Gutiérrez</h1>
                                        <h4>PROGRAMADOR</h4>
                                        </div>
                                    </div>
                                <div className='containerP'>
                                    
                                    <img src='/authors/fotoDavid.jpeg' alt='fotoDavid' className='fotoPerfil'></img>
                                     <div className='descriptionP'>
                                    <h1 >Est. David Guerra</h1>
                                    <h4>PROGRAMADOR</h4>
                                    </div>
                                </div>

                            </div>

                        </section>
                    </main>
                </div>

            </React.Fragment>
        </>
    )
}

